import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, InputGroup, Form, Dropdown } from 'react-bootstrap';
import './MaskedInput.js.css';

export default class MaskedInput extends React.Component {

    static IsLoaded = false;

    static obj_paramters = ["group", "notnull", "label", "data", "files", "name", "uppercase", "lowercase",
        "onvalid", "oninvalid", "max", "min", "date", "value", "text", "password", "maxlength", "placeholder",
        "enter", "up", "left", "down", "right", "space", "button", "hold", "indicator", "icon", "autoComplete"];

    constructor(props) {
        super(props);
        this.input = React.createRef();
        this.state = {
            value: props.value != null ? props.value : null
        };
        this.data = props.data;
        this.parser = props.parser;
        this.key = typeof props.key === "string" ? props.key : null;
        this.type = props.type ? props.type : "text";
        if (typeof props.value !== "undefined" && props.value != null)
            this.state.value = props.value;
        else if (this.type == "select") this.state.value = "";
        this.valid = true;
        this.onValid = props.onValid;
        this.onInvalid = props.onInvalid;
        this.ctrlKey = false;
        this.disabled = false;
        this.lastKey = null;
        this.history = [];
        this.parameters = this.extractParameters(props);
        this.names = this.parameters.name != null ? (typeof this.parameters.name === "string" ? this.parameters.name.split(',') : typeof this.parameters.name === "function" ? this.parameters.name : null) : null;
        if (this.names != null && Array.isArray(this.names) && this.names.length > 0) {
            if (this.names.length == 1) this.names.push(this.names[0]);
        } else if (typeof this.names === "function") { }
        else this.names = null;
    }

    componentDidMount() {
        this.validate(this.input);
    }

    getData() {
        var r = Array.isArray(this.data) ? this.data : [];
        if (typeof this.data === "function") {
            var c = this.data();
            if (Array.isArray(c)) r = c;
        }
        return r;
    }

    render() {
        return <Form.Group key={this.key}>
            {typeof this.parameters.label === "string" && this.parameters.label.length > 0 ?
                <Form.Label>{this.parameters.label}</Form.Label> : null
            }
            <InputGroup className="mb-2">
                <InputGroup.Prepend>
                    <div className={"maskedinput_indicator" + (this.state.valid ? " valid" : " invalid")}></div>
                    {
                        this.parameters.icon != null ?
                            <InputGroup.Text><FontAwesomeIcon icon={this.parameters.icon} /></InputGroup.Text>
                            : null
                    }
                </InputGroup.Prepend>
                {
                    this.type == "select" ?
                        <select className={"form-control"}
                            disabled={this.state.disabled}
                            ref={c => (this.input = c)}
                            title={this.parameters.placeholder}
                            value={Array.isArray(this.state.value) ? this.state.value[0] : this.state.value}
                            onChange={(target) => {
                                this.validate(target.currentTarget);
                            }} >
                            {
                                typeof this.parameters.placeholder === "string" && this.parameters.placeholder.length > 0 ?
                                    <option value="" disabled={this.parameters.notnull == true} >{this.parameters.placeholder}</option>
                                    : null
                            }
                            {
                                this.getData().map(t => {
                                    var v = "", l = "";
                                    if (typeof t === "string") v = l = t;
                                    else if (this.names == null) return null;
                                    else if (typeof this.names === "function") {
                                        var r = this.names(t);
                                        v = r[0];
                                        l = r[1];
                                    }
                                    else {
                                        v = t[this.names[0]];
                                        l = t[this.names[1]];
                                    }
                                    return <option
                                        value={v}>{
                                            typeof this.parser === "function" ? this.parser(l, v, t) : l
                                        }</option>
                                })
                            }
                        </select>
                        :
                        this.type == "textarea" ? 
                        <textarea className={"form-control"}
                        type={this.parseInputType(this.type)}
                        disabled={this.state.disabled}
                        placeholder={this.parameters.placeholder}
                        ref={c => (this.input = c)}
                        autoComplete={this.parameters.autoComplete != false ? "on" : "new-password"}
                        value={this.state.value}
                        onKeyDown={(t) => {
                            this.lastKey = t.which;
                            this.ctrlKey = t.ctrlKey;
                        }}
                        onChange={(target) => {
                            var result = this.validate(target.currentTarget);
                            if (this.parameters.password != true) {
                                if (this.history == null)
                                    this.history = [result];
                                else if (this.history.length == 0 ||
                                    this.history[this.history.length - 1] != result) {
                                    if (this.history.length > 20)
                                        this.history.splice(0, 1);
                                    this.history.push(result);
                                }
                            }
                        }} />
                        :
                        <input className={"form-control"}
                            type={this.parameters.password == true ? "password" : this.parseInputType(this.type)}
                            disabled={this.state.disabled}
                            placeholder={this.parameters.placeholder}
                            ref={c => (this.input = c)}
                            autoComplete={this.parameters.autoComplete != false ? "on" : "new-password"}
                            value={this.state.value}
                            onKeyDown={(t) => {
                                this.lastKey = t.which;
                                this.ctrlKey = t.ctrlKey;
                            }}
                            onChange={(target) => {
                                var result = this.validate(target.currentTarget);
                                if (this.parameters.password != true) {
                                    if (this.history == null)
                                        this.history = [result];
                                    else if (this.history.length == 0 ||
                                        this.history[this.history.length - 1] != result) {
                                        if (this.history.length > 20)
                                            this.history.splice(0, 1);
                                        this.history.push(result);
                                    }
                                }
                            }} />
                }
            </InputGroup>
        </Form.Group >
    }

    parseInputType(type) {
        switch (type) {
            // case "range":
            // case "cep":
            // case "time":
            // case "cpf":
            // case "cnpj":
            // case "fulltel":
            // case "dddtel":
            // case "tel":
            // case "carteirinha":
            // case "decimal":
            // case "int":
            // case "version":
            //     return "number";
            case "email":
                return "email";
        }
        return "text";
    }

    extractParameters(props) {
        var p = {}
        for (let i = 0; i < MaskedInput.obj_paramters.length; i++) {
            const element = MaskedInput.obj_paramters[i];
            if (typeof props === "object" &&
                typeof props[element] !== "undefined") p[element] = props[element];
            else p[element] = null
        }
        return p;
    }

    validate(target) {
        var valid = false;
        if (target instanceof Element && target.nodeName.toLowerCase() == "input" && typeof this.masks[this.type] === "object") {
            if (target.value != "" && target.value != null) {
                var caret = this.getCaret(target), value = this.checkMask(this.masks[this.type], target.value, caret[0]),
                    resultCaret = value[1]; target.value = value[0];
                if (this.lastKey == 8 && caret[0] < resultCaret) resultCaret -= value[2];
                this.setCaret(target, resultCaret);
                this.state.value = value[0];
            } else this.state.value = "";
            if (this.parameters.uppercase == "true") {
                target.value = this.state.value = this.state.value.toUpperCase();
            } else if (this.parameters.lowercase == "true") {
                target.value = this.state.value = this.state.value.toLowerCase();
            }
        } else if (target.nodeName.toLowerCase() == "select" && target.childNodes.length > 0) {
            if (this.parameters.value == null || this.parameters.value == "" || (this.parameters.value != null && target.selectedIndex > 0)) {
                this.state.value = (this.parameters.placeholder != "" &&
                    this.parameters.placeholder != null &&
                    typeof this.parameters.placeholder !== "undefined" && target.selectedIndex > 0) ||
                    (this.parameters.placeholder == "" ||
                        this.parameters.placeholder == null ||
                        typeof this.parameters.placeholder === "undefined") ?
                    [target.childNodes[target.selectedIndex].value, target.childNodes[target.selectedIndex].innerHTML] : null;
                this.startValue = null;
            }
            else this.state.value = null;
        }
        else this.state.value = null;
        if ((typeof this.state.value === "string" && (this.state.value == "" || this.state.value == null)) ||
            (target.nodeName.toLowerCase() == "select" &&
                (target.selectedIndex == 0 || this.state.value == null))) {
            if (this.parameters.notnull != true) valid = true;
        } else if (typeof this.masks[this.type] === "object") {
            valid = this.validateMask(this.masks[this.type], this.state.value);
        } else valid = true;

        this.valid = valid;

        try {
            if (valid == true) this.onvalidr();
            else this.oninvalidr();
        } catch (e) {
            // _creto_error("oninvalid function error", e);
        }
    }

    onvalidr() {
        var v = true;
        if (typeof this.onValid === "function") {
            var r = this.onValid(this.state.value, this);
            if (typeof r === "boolean") v = r;
        }
        if (v != true) {
            this.oninvalidr();
        } else
            this.setState({ valid: v, value: this.state.value });
    }
    oninvalidr() {
        var v = false;
        if (typeof this.onInvalid === "function") {
            var r = this.onInvalid(this.state.value, this);
            if (typeof r === "boolean") v = r;
        }
        if (v != false) {
            this.onvalidr();
        } else
            this.setState({ valid: v, value: this.state.value });
    }
    enable() {
        this.setState({ disabled: false });
    }
    disable() {
        this.setState({ disabled: false });
    }

    getCaret(target, value, data) {
        var s = 0;
        var e = 0;
        if (document.selection) {
            var selection = document.selection.createRange();
            var y = selection.text.length;
            selection.moveStart('character', -target.value.length);
            s = selection.text.length;
            e = s;
            s = s - y;
        } else if (target.selectionStart || target.selectionStart == '0') {
            s = target.selectionStart;
            e = target.selectionEnd - target.selectionStart;
        }
        return [s, e];
    };

    setCaret(target, position) {
        if (target.setSelectionRange) {
            try { target.setSelectionRange(position, position); } catch (e) {
                // _creto_error("settingCaret error", e);
            }
        }
        else if (target.createTextRange) {
            var range = target.createTextRange();
            range.collapse(true);
            range.moveEnd('character', position);
            range.moveStart('character', position);
            try { range.select(); } catch (e) {
                // _creto_error("settingCaret error", e);
            }
        }
    };
    validateMask(mask, value) {
        var valid = false;
        if (typeof mask.valid === "object" && Array.isArray(mask.valid) &&
            mask.valid.length > 0) {
            for (var i = 0; i < mask.valid.length; i++)
                if (mask.valid[i][0] == null || value.length <= mask.valid[i][0])
                    if (mask.valid[i][1].test(value)) valid = true;
        } else if (typeof mask.valid === "function") {
            valid = mask.valid(value, mask.charset, mask);
            if (typeof valid !== "boolean") valid = true;
        }
        else if (typeof mask.length === "number" && mask.length > 0 &&
            value != null && value.length > mask.length) valid = false;
        else valid = true;

        if (valid && typeof mask.check == "function") {
            var thisReturn = mask.check.bind(this)(value);
            if (typeof thisReturn == "boolean") valid = thisReturn;
        }
        return valid;
    }


    checkMask(mask, target, caret) {
        var result = "", value = target, i = 0, cCaret = caret, sMask = 0;

        if (value.length > 0) {
            var rxp = mask.charset;

            var j = value.search(rxp);
            while (j > -1) {
                value = value.slice(0, j) + value.slice(j >= value.length ? value.length : j + 1, value.length);
                if (cCaret > j)
                    cCaret--;
                j = value.search(rxp);
            }
        }

        if (mask.length && value.length > mask.length) {
            if (cCaret >= mask.length)
                cCaret -= value.length - mask.length;
            value = value.slice(0, mask.length);
        }

        var thisMask = null, reverse = false;
        for (var j = mask.mask.length - 1; j >= 0; j--)
            if (mask.mask[j][0] == null || mask.mask[j][0] >= value.length) {
                thisMask = mask.mask[j][1];
                if (mask.mask[j].length > 2 && mask.mask[j][2] == true)
                    reverse = true;
                else reverse = false;
            }
        if (thisMask) {
            if (reverse) {
                value = value.split('').reverse().join('');
                cCaret = value.length - cCaret;
            }
            while (i < thisMask.length && (typeof thisMask[i] === "function" || value.length > thisMask[i][0])) {
                var ml = 0;
                if (typeof thisMask[i] === "function") {
                    var r = thisMask[i](value, this.lastKey, this.ctrlKey);
                    result = r[0];
                    if (result.length >= value.length && this.lastKey == 8) cCaret++;
                    value = "";
                } else {
                    result += value.slice(0, thisMask[i][0]);
                    if (thisMask[i][0] != null)
                        value = value.slice(thisMask[i][0], value.length);

                    result += thisMask[i][1];
                    ml = thisMask[i][1].length;
                    if (cCaret >= result.length) {
                        if (this.lastKey == 8 && cCaret < result.length + ml)
                            sMask = (result.length + ml - cCaret);
                        cCaret += ml;
                    }
                }
                i++;
            }
            if (reverse) {
                result = result.split('').reverse().join('');
                cCaret = result.length - cCaret;
            }
        }

        if (target == result + value) cCaret = caret;
        return [result + value, cCaret, sMask];
    }

    masks = {
        "text": {
            "charset": /(\s\s|^\s|\s\s$)/im,
            "mask": [],
            "valid": [],
            "length": 256
        },
        "url": {
            "charset": /[^a-zA-Z0-9!#$%&'*+-/=?^_`{|}~@:]/im,
            "mask": [],
            "valid": [
                [null, /^((https?|ftp|file):\/\/)?[a-z.0-9\-_%]*(:([0-9])+)?(\/[a-z.0-9\-_%]*)*(\??([a-z.0-9\-_%]+(=[^&\\\/\s]*)?&?)*)$/im]
            ],
            "length": null,
            "keyboard": "email"
        },
        "email": {
            "charset": /[^a-zA-Z0-9!#$%&'*+-/=?^_`{|}~@:]/im,
            "mask": [],
            "valid": [
                [256, /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@[a-z0-9](\.?[-a-z0-9]*[a-z0-9]+)*(\:[1-9][0-9]?[0-9]?[0-9]?[0-9]?)?(\:0)?$/im]
            ],
            "length": 256,
            "keyboard": "email"
        },
        "mname": {
            "charset": /(\s\s|^\s|\s\s$|[^a-zA-Z\xc0-\xff\s])/im,
            "mask": [],
            "valid": [
                [null, /^[a-z\xc0-\xff][a-z\xc0-\xff]+((\s[a-z\xc0-\xff]+)*(\s[a-z\xc0-\xff][a-z\xc0-\xff]+)+)?\s?$/im]
            ],
            "length": 256,
            "keyboard": "letters"
        },
        "sname": {
            "charset": /[^a-zA-Z\xc0-\xff]/im,
            "mask": [],
            "valid": [
                [null, /^[a-z\xc0-\xff][a-z\xc0-\xff]+$/im]
            ],
            "length": 256,
            "keyboard": "letters"
        },
        "bname": {
            "charset": /(\s\s|^\s|\s\s$|[^a-zA-Z\xc0-\xff\s])/im,
            "mask": [],
            "valid": [
                [null, /^[a-z\xc0-\xff][a-z\xc0-\xff]+(\s[a-z\xc0-\xff]+)*\s[a-z\xc0-\xff][a-z\xc0-\xff]+\s?$/im]
            ],
            "length": 256,
            "keyboard": "letters"
        },
        "fname": {
            "charset": /(\s\s|^\s|\s\s$|[^a-zA-Z\xc0-\xff\s])/im,
            "mask": [],
            "valid": [
                [null, /^[a-z\xc0-\xff][a-z\xc0-\xff]+(\s[a-z\xc0-\xff][a-z\xc0-\xff]+)*\s[a-z\xc0-\xff][a-z\xc0-\xff]+\s?$/im]
            ],
            "length": 256,
            "keyboard": "letters"
        },
        "version": {
            "charset": /[^a-z0-9.-]/im,
            "mask": [],
            "valid": [
                [null, /^([a-z]|((([1-9][0-9]*)|0)(.[0-9]+)*(-[a-z])?))$/im]
            ],
            "length": 256,
            "keyboard": "numbers"
        },
        "int": {
            "charset": /[^0-9]/im,
            "mask": [],
            "valid": [
                [null, /^[0-9][0-9]*$/im]
            ],
            "length": 256,
            "keyboard": "numbers"
        },
        "decimal": {
            "charset": /(^(0(?=0))|[^0-9\,\.])/im,
            "mask": [
                [null, [function (t, k, ctrl) {

                    var r = "", v = "" + (t);
                    v = v.replace(/(,|\.)(?![0-9]+$)/ig, "").replace(/[\.\,]/ig, ",");
                    var s = v.split(","), c = t.length - v.length, e = "";
                    // for (var i = 2; i < s.length; i++)
                    //     s[1] += s[i];

                    if (s.length == 1) {
                        v = k == null || (k == 86 && ctrl == true) ? "00" + s[0] : s[0] + "00";
                        c += 2;
                    }
                    else if (s.length >= 2) {
                        if (s[0].length == 1) {
                            v = "0" + s[0] + s[1];
                            if (k == 8)
                                c -= 1;
                        } else if (s[0].length == 0) {
                            v = "00" + s[1];
                            if (k -= 8)
                                c -= 2;
                        }
                        else v = s[0] + s[1];
                    }
                    if (v.length >= 2) {
                        r = v.slice(0, 2) + ",";
                        v = v.slice(2, v.length).replace(/0*$/ig, "");
                        c += 2;
                        if (v.length == 0) {
                            r += "0";
                            v = "";
                            c++;
                        }
                        while (v.length > 3) {
                            r += v.slice(0, 3) + ".";
                            v = v.slice(3, v.length);
                            c++;
                        }
                    } else if (v.length == 1) {
                        r = v + "0,0";
                        c += 3;
                        v = "";
                    } else {
                        r = "00,0"
                        c += 4;
                    }
                    v = r + v;
                    return [v, c];
                }], true]
            ],
            "valid": [
                [null, /^[0-9][0-9]*(\.[0-9][0-9][0-9])*(,[0-9][0-9]?)?$/im]
            ],
            "length": 256,
            "keyboard": "decimal"
        },
        "carteirinha": {
            "charset": /[^0-9]/im,
            "mask": [],
            "valid": [
                [6, /^[0-9][0-9]{5}$/im],
                [19, /^[0-9][0-9]{5}[0-9]+$/im]
            ],
            "length": 19
        },
        "serial": {
            "charset": /[^0-9a-f]/im,
            "mask": [[16, [[4, "-"], [4, "-"], [4, "-"]]]],
            "valid": [
                [19, /^([a-f0-9]{4}\-){3}[a-f0-9]{4}$/ig],
            ],
            "length": 16,
            "keyboard": "letters_numbers_ns"
        },
        "tel": {
            "charset": /[^0-9]/im,
            "mask": [
                [8, [[4, "-"]]],
                [9, [[1, " "], [4, "-"]]],
                [10, [[0, "("], [2, ") "], [4, "-"]]],
                [11, [[0, "("], [2, ") "], [1, " "], [4, "-"]]],
                [12, [[0, "+"], [2, " ("], [2, ") "], [4, "-"]]],
                [13, [[0, "+"], [2, " ("], [2, ") "], [1, " "], [4, "-"]]]
            ],
            "valid": [
                [11, /^[0-9]{4}\-[0-9]{4}$/im],
                [13, /^[0-9]\s[0-9]{4}\-[0-9]{4}$/im],
                [14, /^\([0-9]{2}\)\s[0-9]{4}\-[0-9]{4}$/im],
                [16, /^\([0-9]{2}\)\s[0-9]\s[0-9]{4}\-[0-9]{4}$/im],
                [18, /^\+[0-9]{2}\s\([0-9]{2}\)\s[0-9]{4}\-[0-9]{4}$/im],
                [20, /^\+[0-9]{2}\s\([0-9]{2}\)\s[0-9]\s[0-9]{4}\-[0-9]{4}$/im]
            ],
            "length": 13,
            "keyboard": "numbers"
        },
        "dddtel": {
            "charset": /[^0-9]/im,
            "mask": [
                [10, [[0, "("], [2, ") "], [4, "-"]]],
                [11, [[0, "("], [2, ") "], [1, " "], [4, "-"]]]
            ],
            "valid": [
                [14, /^\([0-9]{2}\)\s[0-9]{4}\-[0-9]{4}$/im],
                [16, /^\([0-9]{2}\)\s[0-9]\s[0-9]{4}\-[0-9]{4}$/im]
            ],
            "length": 13,
            "keyboard": "numbers"
        },
        "fulltel": {
            "charset": /[^0-9]/im,
            "mask": [
                [8, [[4, "-"]]],
                [9, [[1, " "], [4, "-"]]],
                [10, [[0, "("], [2, ") "], [4, "-"]]],
                [11, [[0, "("], [2, ") "], [1, " "], [4, "-"]]],
                [12, [[0, "+"], [2, " ("], [2, ") "], [4, "-"]]],
                [13, [[0, "+"], [2, " ("], [2, ") "], [1, " "], [4, "-"]]]
            ],
            "valid": [
                [11, /^[0-9]{4}\-[0-9]{4}$/im],
                [13, /^[0-9]\s[0-9]{4}\-[0-9]{4}$/im],
                [14, /^\([0-9]{2}\)\s[0-9]{4}\-[0-9]{4}$/im],
                [16, /^\([0-9]{2}\)\s[0-9]\s[0-9]{4}\-[0-9]{4}$/im],
                [18, /^\+[0-9]{2}\s\([0-9]{2}\)\s[0-9]{4}\-[0-9]{4}$/im],
                [20, /^\+[0-9]{2}\s\([0-9]{2}\)\s[0-9]\s[0-9]{4}\-[0-9]{4}$/im]
            ],
            "length": 13,
            "keyboard": "numbers"
        },
        "cnpj": {
            "charset": /[^0-9]/im,
            "mask": [[14, [[2, "."], [3, "."], [3, "/"], [4, "-"]]]],
            // "valid": [
            //     [18, /^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}\-[0-9]{2}$/im]
            // ],
            "valid": function (v, c, m) {
                if (typeof v !== "string") return false;
                var f = v;
                var j = f.search(c);
                while (j > -1) {
                    f = f.slice(0, j) + f.slice(j >= f.length ? f.length : j + 1, f.length);
                    j = f.search(c);
                }
                var m = [], n = false;
                for (var i = 0; i < f.length; i++) {
                    m.push(parseInt(f.substring(i, i + 1)));
                    if (i > 0 && m[i] != m[i - 1]) n = true;
                }

                if (!n || m.length != 14) return false;

                var r = [0, 0, 0];

                for (var k = 1; k < 3; k++) {
                    var o = 0, d = (7 - k);
                    for (var l = 0; l < 12; l++) {
                        if (d > 9) d = 2
                        o += m[l] * d;
                        d++;
                    }
                    r[k] = (o + r[k - 1] * 9) % 11;
                    if (r[k] == 10) r[k] = 0;
                }

                if (r[1] == m[12] && r[2] == m[13])
                    return true;
                return false;
            },
            "length": 14,
            "keyboard": "numbers"
        },
        "cpf": {
            "charset": /[^0-9]/im,
            "mask": [[11, [[3, "."], [3, "."], [3, "-"]]]],
            "valid": function (v, c, m) {
                if (typeof v !== "string") return false;
                var f = v;
                var j = f.search(c);
                while (j > -1) {
                    f = f.slice(0, j) + f.slice(j >= f.length ? f.length : j + 1, f.length);
                    j = f.search(c);
                }
                var m = [], n = false;
                for (var i = 0; i < f.length; i++) {
                    m.push(parseInt(f.substring(i, i + 1)));
                    if (i > 0 && m[i] != m[i - 1]) n = true;
                }
                if (!n || m.length != 11) return false;
                for (var l = 9; l < 11; l++) {
                    j = 0;
                    for (var i = 0; i < l; i++)
                        j += m[i] * ((l + 1) - i);
                    j = 11 - (j % 11);
                    if (j > 9) j = 0;
                    if (j != m[l]) return false;
                }
                return true;
            },
            "length": 11,
            "keyboard": "numbers"
        },
        "time": {
            "charset": /[^0-9]/im,
            "mask": [[6, [[2, ":"], [2, ":"]]]],
            "valid": [[8, /^([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/im]],
            "length": 6,
            "keyboard": "numbers"
        },
        "rg": {
            "charset": /[^a-z0-9]/im,
            "mask": [[8, []], [9, [[2, "."], [3, "."], [3, "-"]]], [10, []]],
            "valid": null,
            "length": 15,
            "keyboard": "letters_numbers_ns"
        },
        "cep": {
            "charset": /[^0-9]/im,
            "mask": [[8, [[5, "-"]]]],
            "valid": [
                [9, /^[0-9]{5}\-[0-9]{3}$/im]
            ],
            "length": 8,
            "keyboard": "numbers"
        },
        "range": {
            "charset": /[^0-9]/im,
            "mask": [],
            "valid": null,
            "length": 256
        },
        "button": {
            "charset": /[^0-9]/im,
            "mask": [],
            "valid": null,
            "length": 256
        },
        "date": {
            "charset": /[^0-9]/im,
            "mask": [[8, [[2, "/"], [2, "/"]]]],
            "valid": [
                [10, /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/(19[1-9][0-9]|20[0-9][0-9])$/im]
            ],
            "length": 8,
            "check": function (value) {
                var date = value.split("/"), valid = true;
                if (parseInt(date[0]) > this.getMonthDays(parseInt(date[2]), parseInt(date[1])))
                    valid = false;
                else {
                    date = new Date(date[2] + "/" + date[1] + "/" + date[0]).getTime();
                    var range = this.getRange(this.state.min, this.state.max);
                    if (range[0] != null && date < range[0])
                        valid = false;
                    else if (range[1] != null && date > range[1])
                        valid = false;
                }
                return valid;
            }, "keyboard": "numeric"
        }
    };


    getMonthDays(year, month) {
        return (32 - new Date(year, month - 1, 32).getDate());
    };

    validateDate(date, parcial) {
        if (parcial)
            return /^(0[1-9]|[1-2][0-9]|3[0-1])?(\/([1-9]|0[1-9]|1[1-2])?|\/(0[1-9]|1[1-2])\/[1-9][0-9]?[0-9]?[0-9]?)?$/im.test(date);
        else
            return /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[1-2])\/[1-9][0-9]?[0-9]?[0-9]?$/im.test(date);
    };

    getRange(min, max) {
        var minDate = false, maxDate = false;
        if (min != null) {
            if (/\//.test(min)) {
                if (this.validateDate(min)) {
                    min = min.split("/");
                    min = new Date(min[2] + "/" + min[1] + "/" + min[0]).getTime();
                    minDate = true;
                } else min = null;
            } else {
                if (typeof min == "string")
                    min = parseInt(min);
                if (isNaN(min)) min = null;
            }
        }
        if (max != null) {
            if (/\//.test(max)) {
                if (this.validateDate(max)) {
                    max = max.split("/");
                    max = new Date(max[2] + "/" + max[1] + "/" + max[0]).getTime();
                    maxDate = true;
                } else max = null;
            } else {
                if (typeof max == "string") max = parseInt(max);
                if (isNaN(max)) max = null;
            }
        }

        if (minDate && maxDate)
            return [min, max];
        else if (minDate)
            return [min, max != null ? this.calcDate(max, min) : null];
        else if (maxDate)
            return [min != null ? this.calcDate(-min, max) : null, max];
        else {
            var thisDate = new Date().getTime();
            return [min != null ? this.calcDate(-min, thisDate) : null,
            max != null ? this.calcDate(max, thisDate) : null];
        }
    };
}